module.exports = __webpack_public_path__ + "2f1b3510d7b097dc59236e3d010cb51a.MP3";